"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RejectError_1 = require("../../../DOM/Error/RejectError");
class ResponseError extends RejectError_1.default {
    constructor(reason, response) {
        super(reason);
        this.response = response;
    }
}
exports.default = ResponseError;
//# sourceMappingURL=ResponseError.js.map